import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import NewTextField from "../../../components/form/TextField";
import { RootState, useSelector } from "redux/store";
import { CustomTheme } from "enums/customTheme";

export default function EmailForm(props: any) {
  const { handleSendEmail } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const customTheme = useSelector(
    (state: RootState) => state.supplier.supplier?.customTheme,
  );

  return (
    <form action="/" method="POST" onSubmit={handleSendEmail}>
      <Stack gap="24px" sx={{ width: "100%" }}>
        <Stack gap="12px">
          <Typography variant="h4" fontWeight={700}>
            {t("email.enterEmail")}
          </Typography>
          <Typography
            fontSize={15}
            lineHeight="22px"
            fontWeight={500}
            color={theme.palette.text.label}
          >
            {t("email.enterEmailCtx")}
          </Typography>
        </Stack>
        <NewTextField
          autoFocus
          required
          id="email"
          label={t("email.emailAddress")}
          type="email"
          sx={{
            "& .MuiInputBase-input": {
              height: "36px",
              padding: "5px 12px",
              borderRadius: "8px",
              color: theme.palette.text.primary,
            },
          }}
        />
        <Button
          fullWidth
          type="submit"
          variant="contained"
          sx={{
            height: 48,
            borderRadius: "8px",
            ...(customTheme === CustomTheme.Volotea && {
              backgroundColor: theme.palette.volotea.red,
              "&:hover": {
                backgroundColor: theme.palette.volotea.redLight,
              },
            }),
          }}
        >
          {t("email.sendCode")}
        </Button>
      </Stack>
    </form>
  );
}
